<div
  class="bg-white rounded-lg px-10 py-7 min-w-sm lg:w-[506px] max-w-[470px] w-full">
  <div class="flex flex-col gap-12 py-7">
    <ng-content />
  </div>
</div>
